import { formatDate as format, formatName } from '../lib/format';
import SectionCard from './ui/SectionCard';
import { useEffect, useState } from 'react';
import { postWithAuth } from '../common';
// Recorded changes to one timesheet: sign-offs made in Site Hub, by admins or by
// client contacts. A client's sign-off writes their hours straight onto the
// timesheet that pay and billing use, so a client change is called out first.
const FIELD_LABELS = { clockIn: 'Start', clockOut: 'Finish', breakMinutes: 'Break', supervisorName: 'Supervisor', supervisorSign: 'Signature', status: 'Status' }

const readableTime = value => {
    if (!value) return '-'
    const date = new Date(value)
    return Number.isFinite(date.getTime()) ? format(date, 'd MMM yyyy, h:mm a') : String(value)
}

export const describeValue = (field, value) => {
    if (value === undefined || value === null || value === '') return '-'
    if (field === 'clockIn' || field === 'clockOut') return readableTime(value)
    if (field === 'breakMinutes') return `${value} mins`
    return String(value)
}

const ChangeList = ({ changes }) => <ul className='timesheetChangeList'>
    {changes.map(change => <li key={change.field}>
        <strong>{FIELD_LABELS[change.field] || change.field}:</strong>{' '}
        {change.field === 'supervisorSign' ? 'signed' : <>{describeValue(change.field, change.before)} &rarr; {describeValue(change.field, change.after)}</>}
    </li>)}
</ul>

export default function TimesheetChangeHistory({ orgId, timeSheet }) {
    const [entries, setEntries] = useState(null)
    const [unavailable, setUnavailable] = useState(false)
    useEffect(() => {
        let current = true
        setEntries(null); setUnavailable(false)
        if (!orgId || !timeSheet?.id) return () => { current = false }
        postWithAuth('fetchTimeSheetHistory', { orgId, timeSheetId: timeSheet.id })
            .then(result => {
                if (!current) return
                // Admins only; anyone else simply does not see the history.
                if (result?.err || !Array.isArray(result?.data)) setUnavailable(true)
                else setEntries(result.data)
            })
            .catch(() => { if (current) setUnavailable(true) })
        return () => { current = false }
    }, [orgId, timeSheet?.id])

    const clientEdit = timeSheet?.clientEdit
    if (!clientEdit && (unavailable || !entries?.length)) return null
    return <SectionCard className='timesheetDetailCard timesheetChangeHistory' title={<>Changes</>}>

        {clientEdit && <div className='timesheetClientEditNotice' role='note'>
            <p><span className='timesheetClientEditBadge'>Edited by client</span> {formatName(clientEdit.actorName) || 'A client contact'} changed these hours when signing off in Site Hub, {readableTime(clientEdit.at)}. Pay and billing use the hours shown above.</p>
            <ChangeList changes={clientEdit.changes || []} />
        </div>}
        {entries?.length > 0 && <ol className='timesheetChangeEntries'>
            {entries.map(entry => <li key={entry.id}>
                <p><strong>{formatName(entry.actorName) || 'Team member'}</strong>{entry.actorRole === 'client' ? ' (Client)' : ''} · {readableTime(entry.createdAt)}</p>
                {entry.action && <p className='timesheetChangeAction'>{entry.action}</p>}
                {entry.changes?.length ? <ChangeList changes={entry.changes} /> : <p className='timesheetChangeAction'>No changes to this timesheet.</p>}
            </li>)}
        </ol>}
    </SectionCard>
}
